const groupResources = {
  en: {
    group: {
      title: 'Group',
      description:
        'The insurance company "Alatau City Garant" is part of the  Company First Heartland, one of the largest financial groups in the Republic of Kazakhstan providing a wide range of investment and banking products on the Kazakh market.',
      subtitle: 'The composition of the group First Heartland:',
      text1: '"Nazarbayev University" AOE',
      text2: '"Nazarbayev Intellectual Schools"',
      text3: '"Nazarbayev Foundation" Private Foundation AOE',
      text4: '«First Heartland Securities» JSC',
      text5: '«Jýsan Invest» JSC',
      text6: '«First Heartland Jýsan Bank» JSC',
    },
  },
  kz: {
    group: {
      title: 'Топ',
      description:
        '«Alatau City Garant» сақтандыру компаниясы Қазақстан нарығында инвестициялық және банктік өнімдердің кең таңдауын ұсынатын, Қазақстан Республикасындағы ірі қаржы топтарының бірі - First Heartland Компаниялар Тобына кіреді.',
      subtitle: 'First Heartland тобының құрамы:',
      text1: '«Назарбаев Университеті» ДББҰ',
      text2: '«Назарбаев Интеллектуалдық Мектептері» ДББҰ',
      text3: '«Назарбаев қоры» жеке қоры',
      text4: '«First Heartland Securities» АҚ',
      text5: '«Jýsan Invest» АҚ',
      text6: '«First Heartland Jýsan Bank» АҚ',
    },
  },
  ru: {
    group: {
      title: 'Группа',
      description:
        'Страховая компания «Alatau City Garant» входит в Группу Компаний First Heartland, одну из крупнейших финансовых групп в Республики Казахстан предоставляющих на казахстанском рынке широкий спектр инвестиционных и банковских продуктов.',
      subtitle: 'Состав группы First Heartland:',
      text1: 'АОО «Назарбаев Университет»',
      text2: 'АОО «Назарбаев Интеллектуальные Школы»',
      text3: 'Частный фонд «Назарбаев фонд»',
      text4: 'АО «First Heartland Securities»',
      text5: 'АО «Jýsan Invest»',
      text6: 'АО «First Heartland Jýsan Bank»',
    },
  },
};

export default groupResources;
